import React from 'react';
import EmployeeCentralContent from '../components/EmployeeCentralContent/EmployeeCentralContent';
import CtaSection from '../components/CtaSection/CtaSection';

const EmployeeCentralPage = () => {
  return (
    <>
      <EmployeeCentralContent />
      <CtaSection />
    </>
  );
};

export default EmployeeCentralPage;
